import React from 'react';
import { Grid, makeStyles, createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import AccountLocation from '../../../../static/outageMapIcons/accountLocationIcon.svg';
import AccountOutageIcon from '../../../../static/outageMapIcons/accountOutageIcon.svg';
import CustomersAffected from '../../../../static/outageMapIcons/customersAffected.svg';
import GroupedOutages from '../../../../static/outageMapIcons/groupedOutages.svg';
import OutageEventWithCount from '../../../../static/outageMapIcons/outageEventWithCount.svg';
import OutageEventWithMoreCount from '../../../../static/outageMapIcons/outageEventWithCount1.svg';
import SelectedOutageLocation from '../../../../static/outageMapIcons/selectedOutageLocation.svg';
import colors from '../../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    legendIcon: {
      marginRight: theme.spacing(1.25),
      width: 24,
      height: 24,
    },
    iconStyles: {
      width: 24,
      height: 24,
    },
    serviceAreaBoundary: {
      backgroundColor: colors.rhinoBlack,
      height: '2px',
    },
  }),
);

const AccountLocationWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <AccountLocation className={classes.iconStyles} />
    </Grid>
  );
};

const AccountOutageIconWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <AccountOutageIcon className={classes.iconStyles} />
    </Grid>
  );
};

const CustomersEffectedWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <CustomersAffected className={classes.iconStyles} />
    </Grid>
  );
};

const GroupedOutagesWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <GroupedOutages className={classes.iconStyles} />
    </Grid>
  );
};

const OutageEventWithCountWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <OutageEventWithCount className={classes.iconStyles} />
    </Grid>
  );
};

const OutageEventWithMoreCountWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <OutageEventWithMoreCount className={classes.iconStyles} />
    </Grid>
  );
};

const SelectedOutageLocationWrapper = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.legendIcon} item component="span">
      <SelectedOutageLocation className={classes.iconStyles} />
    </Grid>
  );
};

const ServiceAreaBoundary = () => {
  const classes = useStyles();
  return (
    <Grid
      className={clsx(classes.legendIcon, classes.serviceAreaBoundary)}
      item
      component="span"
    ></Grid>
  );
};

export {
  AccountLocationWrapper,
  AccountOutageIconWrapper,
  CustomersEffectedWrapper,
  GroupedOutagesWrapper,
  OutageEventWithCountWrapper,
  OutageEventWithMoreCountWrapper,
  SelectedOutageLocationWrapper,
  ServiceAreaBoundary,
};
